<template>
  <div class="map">
     <l-map
      :zoom="zoom"
      :center="center"
      :options="mapOptions"
      class="olmap"
      ref="leafletMap"
      @update:zoom="zoom => currentZoom = zoom"
      @ready="initMap"
    >
      <l-tile-layer
        :url="url"
        :attribution="attribution"
      />
      <l-control-zoom position="topright"  ></l-control-zoom>
      <Track />
      <v-marker-cluster ref="clusterRef" class="cluster" :options="{ spiderfyOnMaxZoom: false, disableClusteringAtZoom: 15 }" >
        <div v-for="car in cars" :key="car.id">
          <div v-if="selectedCar !== car">
            <MapMarker :car="car"/>
          </div>
        </div>
      </v-marker-cluster>

      <MapMarker v-if="selectedCar" :car="selectedCar"/>

      <SelectedMarker />

    </l-map>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { latLng } from 'leaflet'

export default {
  name: 'OLMap',
  props: ['resize'],
  computed: {
    ...mapState('taxi/mapcars', {
      cars: state => state.items,
      track: state => state.track,
      selectedCar: state => state.items.find(car => state.selectedCar && car.id === state.selectedCar.id)
    }),
    ...mapGetters('taxi/mapcars', [
      'getSelected'
    ])
  },
  data () {
    return {
      zoom: 11,
      marker: '',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      center: latLng(57.1418583, 65.5413183),
      currentZoom: 11.5,
      defaultZoom: 13,
      currentCenter: latLng(47.41322, -1.219482),
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false
      }
    }
  },
  methods: {
    ...mapActions('taxi/mapcars', [
      'selectCar'
    ]),
    initMap () {
      this.map = this.$refs.leafletMap.mapObject
    }
  },
  watch: {
    getSelected () {
      if (this.map && this.getSelected && this.getSelected.lastState) {
        const targetPoint = this.map.project(
          latLng(this.getSelected.lastState.lat.value, this.getSelected.lastState.lng.value),
          this.currentZoom >= this.defaultZoom ? this.currentZoom : this.defaultZoom
        )
        const targetLatLng = this.map.unproject(targetPoint,
          this.currentZoom >= this.defaultZoom ? this.currentZoom : this.defaultZoom
        )
        this.map.setView(targetLatLng,
          this.currentZoom >= this.defaultZoom ? this.currentZoom : this.defaultZoom
        )
      }
    },
    resize () {
      this.map.invalidateSize()
    },
    track () {
      if (this.track.length) {
        this.map.fitBounds(this.track, { padding: [0, 5], maxZoom: 13 })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/globals.scss";

.olmap {
  height: calc(100vh - #{$bwlayuotHeader});
}

@media screen and (max-width: 1199px) {
  .olmap {
    height: calc(39vh - #{$bwlayuotHeader});
  }
}

</style>

<style lang="scss" scoped>
@import "~leaflet/dist/leaflet.css";
@import "~leaflet.markercluster/dist/MarkerCluster.css";
@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  ::v-deep .marker-cluster-medium,
  ::v-deep .marker-cluster-large,
  ::v-deep .marker-cluster-small {
    background-color: rgba(121, 217, 217, 0.6) !important;
    div {
      background-color: rgba(4, 157, 217, 0.6) !important;
      color: #fff !important;
    }
  }

</style>
